import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getUsers = (): Promise<ISelectModel<string>[]> =>
  API.get('/api/security/users').then(response => response?.data);
